export default "__VITE_ASSET__qNLJQ4xn__"